import styles from "../../../../propertydetails.module.css";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import NumberFormat from "react-number-format";

function MoneyField(props) {
    return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={false} allowNegative={false} decimalScale={0} {...props} />);
}

function MoneyFieldTwo(props) {
    return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={2} {...props} />);
}

const schema = yup.object().shape({
    grace_period: yup.string().required("This field is Required").test("non-zero-validate", "This field should be 1 or greater.", (value) => parseInt(value) > 0).test("max-30", "This field can not be more than 30.", (value) => {
        return parseInt(value?.replace(/,/g, "")) <= 30;
    }),
    type_of_fee: yup.string().required("This field is Required"),
    fee_amount: yup.string().when("type_of_fee", (type_of_fee) => {
        if (type_of_fee && parseInt(type_of_fee) === 0)
            return yup.string().required("This field is Required").test("max-4-digit", "Amount can not be more than 6 digits.", (value) => { return parseFloat(value?.replace(/,/g, "")) < 10000; });
        else
            return yup.string().required("This field is Required").test("max-100", "Percentage can not be more than 100.", (value) => { return parseFloat(value?.replace(/,/g, "")) <= 100; });
    }),
});

const NSFFeeSettings = ({ setLoading, property_id, late_fee_data, onUpdate }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();

    const { handleSubmit, control, errors, setValue, watch } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema),
        defaultValues: {
            type_of_fee: "",
        },
    });

    useEffect(() => {
        if (late_fee_data) {
            setValue("grace_period", late_fee_data?.grace_period);
            setValue("type_of_fee", late_fee_data?.type_of_fee);
            setValue("fee_amount", late_fee_data?.fee_amount);
        }
    }, [late_fee_data, setValue]);

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        if (data?.fee_amount) {
            data = { ...data, fee_amount: data?.fee_amount?.replace(/[,%]/g, "") };
        }
        return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/update-payment-settings", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            onUpdate(response.data);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ maxWidth: "300px" }}>
            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`grace_period`}
                        control={control}
                        render={(field) => (<MoneyField
                            onChange={(e) => field.onChange(e)}
                            id="outlined-basic"
                            variant="outlined"
                            label="Grace period*"
                            value={field?.value}
                            inputProps={{ maxLength: 2 }}
                        />)}
                    />
                    {errors.grace_period && (<p className={`${styles.ErrorM}`}>{errors.grace_period.message}</p>)}
                </div>
            </div>

            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Fee Type*</InputLabel>
                        <Controller
                            name="type_of_fee"
                            control={control}
                            render={(field) => (<Select
                                {...field}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Fee Type"
                                onChange={(e) => {
                                    field.onChange(e);

                                    setValue("fee_amount", "");
                                }}
                            >
                                <MenuItem value={0}>Fixed Amount</MenuItem>
                                <MenuItem value={1}>% of Outstanding Balance</MenuItem>
                                <MenuItem value={2}>% of Rent Bill</MenuItem>
                            </Select>)}
                        />
                    </FormControl>
                    {errors.type_of_fee && (<p className={`${styles.ErrorM}`}>{errors.type_of_fee.message}</p>)}
                </div>
            </div>

            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`fee_amount`}
                        control={control}
                        render={(field) => (<MoneyFieldTwo
                            onChange={(e) => field.onChange(e)}
                            id="outlined-basic"
                            variant="outlined"
                            label={watch("type_of_fee") === 0 ? "Amount*" : "Percentage*"}
                            value={field?.value}
                            fixedDecimalScale={watch("type_of_fee") === 0}
                            suffix={watch("type_of_fee") === 0 ? "" : "%"}
                        />)}
                    />
                    {errors.fee_amount && (<p className={`${styles.ErrorM}`}>{errors.fee_amount.message}</p>)}
                </div>
            </div>

            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div className={`${styles.ButtonDiv}`}>
                <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>
            </div>}
        </div>
    </form>)
}

export default NSFFeeSettings;